export const SAVE = 'step16.SAVE';
export const VALUE_CHANGED = 'step16.VALUE_CHANGED';
export const LOAD = 'step16.VALUE_LOAD';
export const RESET = 'step16.RESET';
export const RESET_GIVE_PERMISSION_STATE = 'step16.RESET_GIVE_PERMISSION_STATE';
export const SET_DEFAULT_VALUE = 'step16.SET_DEFAULT_VALUE';
export const LOAD_CHECK_NAME = 'step16.LOAD_CHECK_NAME';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step16/constants.js